module.exports = __webpack_public_path__ + "img/jcb.70f726d1.png";